import { jsx as _jsx } from "react/jsx-runtime";
import { CatButton } from '@blocks-react/components/Button';
import styles from '../NotificationDrawer.module.scss';
export const ExpiredStatus = ({ isTodayDate, link, REVIEW_QUOTE, VIEW_QUOTE, }) => {
    return (_jsx("div", { "data-testid": "content-notification", className: `d-flex justify-content-start align-items-center ${styles['order-expired']}`, children: _jsx(CatButton, { href: link, "data-testid": "expiredCta", children: isTodayDate ? REVIEW_QUOTE : VIEW_QUOTE }) }));
};
